module.exports = __webpack_public_path__ + "static/img/muJu.a0262b78.jpg";